<template>
	<div class="input__wrapper input__wrapper--checkbox" ref="selectCheckbox">
		<span class="input-label" :id="data.labelId">{{ data.label }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>
			<treeselect
				:disabled="isFilterHidden"
				:multiple="data.multiple"
				:clearable="true"
				:clear-on-select="clearOnSelect"
				:close-on-select="closeOnSelect"
				:id="data.inputId"
				:options="data.options"
				v-model="inputVal"
				:required="data.required"
				:placeholder="data.placeholder"
				@open="openOnFocus"
				@close="focusOut"
				:flat="flat"
				:backspaceRemoves="backspaceRemoves"
			/>
				<!-- :limit="1" -->
	</div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		isFilterHidden: {
			type: Boolean,
			require: false
		},
		bouncingFlag: {
			require: false
		}
	},
	data () {
		return {
			inputVal: this.value,
			clearOnSelect: true,
			clearable: true,
			closeOnSelect: true,
			backspaceRemoves: false,
			flat: true
		};
	},
	components: {
		Treeselect
	},
	watch: {
		inputVal(val, oldVal) {
			if (this.bouncingFlag) {
				const parsedOldVal = oldVal ? JSON.parse(JSON.stringify(oldVal)) : [];
				const parsedValue = val ? JSON.parse(JSON.stringify(val)) : [];   
				if (JSON.stringify(parsedOldVal) === JSON.stringify(parsedValue)) {
					return;
				}
				if ((Object.keys(parsedValue).length > 0 || (Array.isArray(parsedValue) && parsedValue.length > 0))) {
					this.$emit('treeSelectChange', { val: parsedValue, label: this.data.label.toLowerCase().split(' ').join('_') });
				} else {
					// When input is cleared emit empty value for update
					if (this.data.multiple) {
						this.$emit('treeSelectChange', { val: [], label: this.data.label.toLowerCase().split(' ').join('_') });
					} else {
						this.$emit('treeSelectChange', { val: '', label: this.data.label.toLowerCase().split(' ').join('_') });
					}
				}
			} else {
				if (val) {
					this.$emit('input', val);
				} else {
					// When input is cleared emit empty value for update
					if (this.data.multiple) {
						this.$emit('input', []);
					} else {
						this.$emit('input', '');
					}
				}
			}
		}
	},
	methods: {
		openOnFocus() {
			this.$refs.selectCheckbox.classList.add('select-has-value');
		},
		focusOut() {
			this.$refs.selectCheckbox.classList.remove('select-has-value');
		},
		setValue(value) {
			if (value) {
				if (value === '[]') {
					this.inputVal = null;
					return;
				}

				if (!value.length) {
					this.inputVal = this.value;
					return;
				}
				// NOTE: Refactor because of new agent
				if (Array.isArray(value)) {
					if (value.length > 0) {
						this.inputVal = value;
					}
				} else {
					this.inputVal = value;
					
					if (this.data.multiple || value.includes('"')) {
						this.inputVal = JSON.parse(value);
					}
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.asInputSelect {
	display: block;
	box-shadow: none;
	border: 1px solid $grey-light;
	padding: 15px 20px;
	line-height: 1.2;
	width: 100%;
	font-size: 14px;
	width: 100%;
	font-family: $font-main;
	line-height: 1.2;
	color: $fiord;
    transition: $dur $ease;

	@include mq($sm) {
		font-size: 16px;
		padding: 13px;
	}

    &:focus {
        border: 1px solid $dodger-blue;
    }

	@include placeholder {
		color: $grey;
	}
}
</style>
